export default __webpack_public_path__ + "static/media/3.26a9e6de.png";